import {fetchAndDeserialize} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';
import {ReviewsAndAnswersFilterStateType} from '../filter/reviews-and-answers-statistics-filter-type';
import {reviewsAndAnswersApiFilterValues} from '../filter/reviews-and-answers-statistics-helper';

import {usedAutoRepliesCountSchema, UsedAutoRepliesCountType} from './used-auto-replies-count-type';

export function fetchUsedAutoRepliesCount(
    filter: ReviewsAndAnswersFilterStateType,
    mainFilterKey: string
): Promise<UsedAutoRepliesCountType> {
    return fetchAndDeserialize(
        `/cp/reviews/statistics/auto_replies/?${objectToUrlParameters(
            reviewsAndAnswersApiFilterValues(filter, mainFilterKey)
        )}`,
        usedAutoRepliesCountSchema
    );
}
